import React, { useEffect, useState } from "react";
import { useForm } from "../../../../../hooks/useForm";
import { FormModal } from "../../internas/planes/FormModal";
import { useHistory } from "react-router-dom";

export const NuevoUsuario = () => {
    const history = useHistory();

    const [formValues, handleInputChange] = useForm({
        documento: ""
    });

    const { documento } = formValues;

    const [errorDocument, seterrorDocument] = useState(null);
    const [checkbox, setcheckbox] = useState(false);
    const [errorCheckbox, seterrorCheckbox] = useState(null);
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        //cambios del checkbox
        document.querySelector("#cbox").addEventListener("change", function() {
            if (this.checked) {
                setcheckbox(true);
            } else {
                setcheckbox(false);
            }
        });
    }, []);

    let handleOpen = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "1";
        backdrop.style.zIndex = "99999";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "1";
        form.style.zIndex = "999999";

        const optionsBodyScroll = {
            reserveScrollBarGap: true
        };

        disableBodyScroll(backdrop, optionsBodyScroll);
    };

    let checkValues = () => {
        const regex = /^[0-9]*$/;
        const onlyNumbers = regex.test(documento);

        if (!onlyNumbers || documento.length < 8) {
            seterrorDocument("Debe tener solo números y ser mayor de 8 cifras");
        } else {
            seterrorDocument("");
        }

        if (!checkbox) {
            seterrorCheckbox("Acepta Términos y condiciones para continuar");
        } else {
            seterrorCheckbox("");
        }

        if (onlyNumbers && documento.length >= 8 && checkbox) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    };

    let handleClose = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "0";
        backdrop.style.zIndex = "-1";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "0";
        form.style.zIndex = "-1";
        enableBodyScroll(backdrop);
    };

    useEffect(() => {
        if (isValid) {
            handleSubmit();
        }
    }, [isValid]);

    let handleSubmit = e => {
        if (e) {
            e.preventDefault();
        }

        checkValues();

        if (isValid) {
            sessionStorage.setItem("ctLocal", btoa(documento));

            history.push("/nuevo_usuario_cuil");
        }
    };

    return (
        <>
            <div className="login">
                <div className="login_title">
                    <h1>CREAR NUEVO USUARIO</h1>
                </div>
                <div className="login_formDiv">
                    <div className="login_formDiv--desktop">
                        <div className="login_formDiv--desktop--form">
                            <form
                                className="login_form"
                                onSubmit={handleSubmit}
                            >
                                <h1>USUARIO NUEVO</h1>
                                <input
                                    className={`${
                                        errorDocument != null &&
                                        errorDocument != ""
                                            ? "login_form--input errorInput"
                                            : "login_form--input"
                                    } `}
                                    placeholder="CUIT / CUIL"
                                    name="documento"
                                    value={documento}
                                    onChange={handleInputChange}
                                />
                                <p
                                    className={`${
                                        errorDocument != null &&
                                        errorDocument != ""
                                            ? "errorMsgInput"
                                            : ""
                                    } `}
                                >
                                    {errorDocument}
                                </p>

                                <div className="checkboxInput">
                                    <div className="text">
                                        Acepto{" "}
                                        <a onClick={handleOpen}>
                                            Términos y Condiciones
                                        </a>
                                    </div>
                                    <label className="content-input ml-octa">
                                        <input
                                            type="checkbox"
                                            name="Vehiculo"
                                            id="cbox"
                                            value="checkbox"
                                        />
                                        <i></i>
                                    </label>
                                </div>
                                <p className="text-rojo">{errorCheckbox}</p>
                                <button
                                    className="login_form--button mt-base"
                                    type="submit"
                                >
                                    Registrarse
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <FormModal handleClose={handleClose} />
        </>
    );
};
